function validateNameInput(input, required, placeholder) {
    if (placeholder === void 0) { placeholder = "שם"; }
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return "\u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 " + placeholder;
    else if (input.length > 20)
        return "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E4\u05D7\u05D5\u05EA \u05DE20 \u05EA\u05D5\u05D5\u05D9\u05DD";
    else {
        var res = /[\u0590-\u05FF   \"\-\'a-zA-Z]*/i.exec(input);
        if (res[0] !== input)
            return "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E8\u05E7 \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA";
    }
    return '';
}
function validateUsernameInput(input, required, placeholder) {
    if (placeholder === void 0) { placeholder = "שם משתמש"; }
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return "\u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 " + placeholder;
    else if (input.length > 20)
        return placeholder + " \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E4\u05D7\u05D5\u05EA \u05DE20 \u05EA\u05D5\u05D5\u05D9\u05DD";
    else {
        var res = /[a-z0-9\u0590-\u05FF_.-]*/i.exec(input);
        if (res[0] !== input)
            return placeholder + " \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E8\u05E7 \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D5\u05DE\u05E1\u05E4\u05E8\u05D9\u05DD";
    }
    return '';
}
function validateFullNameInput(input, required) {
    var res = /[\u0590-\u05FF \" \' \s]*/i.exec(input);
    if (input && !input.length && !required)
        return '';
    else if (input.length > 30)
        return 'השם חייב להכיל פחות מ30 תווים';
    //TODO make sure that the following regex is only hebrew letters and at least one space between leters
    //without counting spaces at beggining or end of input
    else if (res[0] !== input)
        return "\u05D4\u05E9\u05DD \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E8\u05E7 \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D1\u05E2\u05D1\u05E8\u05D9\u05EA";
    else if (!input || !input.length || !/[\u0590-\u05FF \" \' \s]\s{1,}[\s \" \' \u0590-\u05FF]/.test(input))
        return 'אנא הכנס שם פרטי ושם משפחה';
    return '';
}
//TODO one day- allow +972
// validatePhoneInput supports the following phone formats: (the first part can be either 2 or 3 numbers)
// (023) 456 7899
// (023)-456-7899
// 023-456-7899
// 023 456 7899
// 0234567899
function validatePhoneInput(input, required, length) {
    if (length === void 0) { length = 10; }
    input = input.replace(/[^0-9]/g, "");
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return 'אנא הכנס מספר טלפון (ספרות בלבד)';
    else if (input.length !== length)
        return "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05D1\u05D3\u05D9\u05D5\u05E7 " + length + " \u05EA\u05D5\u05D5\u05D9\u05DD";
    else if (!(/^0\(?([0-9]{1,2})\)?([ -]?)([0-9]{3})\2([0-9]{4})/.test(input)))
        return 'מספר הטלפון לא תקין (ספרות בלבד)';
    // else if(/^\d+$/.test(input)) return 'Must include only numbers';
    return '';
}
function validateEmailInput(input, required) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return 'אנא הכנס כתובת מייל';
    else if (!regex.test(input))
        return 'כתובת המייל שגויה';
    return '';
}
function validatePasswordInput(input, required) {
    var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^().~`\[\]{}\|\\-_=+<>:"?])[A-Za-z\d@$!%*?&#^().~`\[\]{}\|\\-_=+<>:"?]{8,}$/;
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return 'אנא הכנס סיסמא';
    else if (input.length < 8)
        return 'הסיסמא חייבת להכיל לפחות 8 תווים';
    else if (!regex.test(input))
        return 'הסיסמא חייבת להכיל מספר, תו מיוחד, אות גדולה ואות קטנה באנגלית';
    return '';
}
function validateConfirmPasswordInput(input, required, pw) {
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return 'אנא הכנס אימות סיסמא';
    if (input !== pw)
        return 'הסיסמאות אינן תואמות';
    return '';
}
function validateSelectInput(input, required, placeholder) {
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 " + placeholder;
    return '';
}
function validateStringInput(input, required, placeholder, length) {
    if ((!input || !input.length) && !required)
        return '';
    else if (!input || !input.length)
        return "\u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 " + placeholder;
    else if (input.length > length)
        return "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E4\u05D7\u05D5\u05EA \u05DE" + length + " \u05EA\u05D5\u05D5\u05D9\u05DD";
    // else if (/\d/.test(input)) return 'לא יכול להכיל מספרים';
    return '';
}
function validateAddressInput(input, required) {
    var res = /['\u0590-\u05FF \s 0-9]*/i.exec(input);
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return 'אנא הכנס כתובת ומספר בית';
    else if (!/\d/.test(input) || res[0] !== input || !/['\u0590-\u05FF]/.test(input))
        return 'חייב להכיל כתובת בעברית ומספר';
    else if (!/^['\u0590-\u05FF ]* [0-9]*[0-9  ]$/.test(input) && !/^[0-9  ][0-9]* ['\u0590-\u05FF ]*$/.test(input))
        return 'כתובת המגורים שהזנת שגויה';
    return '';
}
//should check max of number (smaller than largest int/int(11))
var maxIntValue = 999999999; //2147483647;
function validateNumberInput(input, required, placeholder) {
    if (input && !input.length && !required)
        return '';
    else if (!input || !input.length)
        return "\u05D0\u05E0\u05D0 \u05D4\u05DB\u05E0\u05E1 " + placeholder;
    else if (input <= 0)
        return "\u05E2\u05DC \u05D4" + placeholder + " \u05DC\u05D4\u05D9\u05D5\u05EA \u05D2\u05D3\u05D5\u05DC \u05DE-0";
    else if (input > maxIntValue)
        return "\u05E2\u05DC \u05D4" + placeholder + " \u05DC\u05D4\u05DB\u05D9\u05DC \u05E2\u05D3 9 \u05E1\u05E4\u05E8\u05D5\u05EA"; //return `על ה${placeholder} להיות קטן מ-${maxIntValue}`;
    else if (!Number.isInteger(Number(input)))
        return "\u05E2\u05DC \u05D4" + placeholder + " \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05E9\u05DC\u05DD";
    return '';
}
/**
 * @param {string} input
 * @param {boolean} [required]
 */
function validateYoutubePathInput(input, required) {
    if ((!input || !input.length) && !required)
        return '';
    else if (!input || !input.length)
        return 'אנא הכנס קישור';
    else if (!/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/.test(input))
        return 'הקישור שהזנת שגוי';
    return '';
}
export default {
    validateFullNameInput: validateFullNameInput,
    validateNameInput: validateNameInput,
    validatePhoneInput: validatePhoneInput,
    validateEmailInput: validateEmailInput,
    validatePasswordInput: validatePasswordInput,
    validateConfirmPasswordInput: validateConfirmPasswordInput,
    validateSelectInput: validateSelectInput,
    validateStringInput: validateStringInput,
    validateAddressInput: validateAddressInput,
    validateNumberInput: validateNumberInput,
    validateUsernameInput: validateUsernameInput,
    validateYoutubePathInput: validateYoutubePathInput
};
//# sourceMappingURL=ValidateFields.js.map